
import { Line } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    LineElement,
    LinearScale,
    PointElement,
    Filler,
    Tooltip,
    Legend,
    CategoryScale,
} from 'chart.js';
import { Card } from 'primereact/card';
import { useGetMonthlyStatus } from '../../hooks/useGetDataQuery';
import { BlockUI } from 'primereact/blockui';

ChartJS.register(
    LineElement,
    LinearScale,
    PointElement,
    Filler,
    Tooltip,
    Legend,
    CategoryScale
);

const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
        legend: {
            display: true,
            position: 'bottom' as const,
            align: 'end' as const,
            labels: {
                color: '#727A99',
                usePointStyle: true,
                pointStyle: 'line',
                font: { size: 18, family: 'inherit' },
            },
        },
        tooltip: {
            mode: 'index' as const,
            intersect: false,
        },
    },
    scales: {
        x: {
            grid: {
                display: false,
                drawBorder: false,
            },
            border: {
                display: false,
            },
            ticks: {
                color: '#727A99',
                font: { size: 10, family: 'inherit' },
            },
        },
        y: {
            min: 0,
            max: 100,
            grid: {
                color: '#E6EAF2',
                drawBorder: false,
                tickBorderDash: [2, 3],
                tickLength: 1,
            },
            border: {
                display: false,
                dash: [4, 4]
            },
            ticks: {
                color: '#727A99',
                font: { size: 10, family: 'inherit' },
                callback: function(tickValue: string | number) {
                    return `${tickValue} %`;
                },
                stepSize: 20,
            },
        },
    },
};

const MonthlyReport = ({t}:any) => {
    const { data:monthlyStatusData, isPending } = useGetMonthlyStatus();

    const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const months = monthlyStatusData
        ? monthlyStatusData.map((item: any) => t(monthNames[item.month - 1]))
        : [];

    const data = {
        labels: months,
        datasets: [
            {
                label: t('success'),
                data: monthlyStatusData?.map((item:any) => item.successPercentage),
                borderColor: '#6ED6B7',
                backgroundColor: 'rgba(110, 214, 183, 0.15)',
                tension: 0.4,
                fill: false,
                pointRadius: 0,
                borderWidth: 3,
                borderCapStyle: 'round' as const,
            },
            {
                label: t('adherence'),
                data: monthlyStatusData?.map((item:any) => item.adherencePercentage),
                borderColor: '#6383F4',
                backgroundColor: 'rgba(99, 131, 244, 0.15)',
                tension: 0.4,
                fill: false,
                pointRadius: 0,
                borderWidth: 3,
                borderCapStyle: 'round' as const,
            },
        ],
    };

    return (
        <div className="col">
            <BlockUI
                blocked={isPending}
                style={{ backgroundColor: "transparent", borderRadius: "24px" }}
                template={
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <dotlottie-player
                        src="https://lottie.host/102dcba8-b9a9-447a-af8e-3e134e77ea0c/Esb1U6xLam.lottie"
                        background="transparent"
                        speed="1"
                        style={{ width: "3rem", height: "3rem" }}
                        loop
                        autoplay
                    />
                </div>
                }
            >
                <Card className="h-16rem" style={{ borderRadius: "24px", position: "relative" }}>
                    <p className='m-0 text-lg' style={{ color: '#727A99' }}>{t("monthlyReport")}</p>
                    <div style={{ position: "relative", width: '25rem', height: '13rem' }}>
                        <Line data={data} options={options} />
                    </div>
                </Card>
            </BlockUI>
        </div>
    );
}

export default MonthlyReport;